export default __webpack_public_path__ + "static/media/CT_Banner.82de447c.png";